import React from "react";
import { Modal, Spinner } from "components/ui";
import { IconButton } from "@mui/material";
import { Button } from "components/ui_new/index";
import { Close } from "@mui/icons-material";
import { Formik, Form } from "formik";
import { TextInput } from "components/form_new";
import { changePassword } from "actions/user";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import useTranslate from "hooks/use-translate-language";

const PASSWORD_EXP = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;

const ChangePasswordModal = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  return (
    <Modal
      renderTrigger={({ openModal }) => (
        <Button
          style={{ width: "100%", color: "black" }}
          sx={{
            justifyContent: "left",
            "& .MuiTouchRipple-root": {
              "& .MuiTouchRipple-ripple": {
                color: "#1890ff"
              }
            },
            "@media (max-width: 640px)": {
              justifyContent: "center"
            }
          }}
          variant="outlined"
          color="primary"
          onClick={() => {
            openModal();
          }}
        >
          {translate("changePassword")}
        </Button>
      )}
      aria-labelledby="change-password-title"
      renderContent={({ closeModal }) => (
        <div
          style={{
            minHeight: 300,
            display: "flex",
            flexDirection: "column",
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 20,
            paddingBottom: 20,
            position: "relative"
          }}
        >
          <IconButton
            onClick={closeModal}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              minWidth: "auto",
              padding: "8px"
            }}
            size="small"
            type="button"
            aria-label={translate("close")}
          >
            <Close aria-hidden="true" />
          </IconButton>

          <h2 id="change-password-title"> {translate("changePassword")}</h2>
          <Formik
            onSubmit={async values => {
              const { success } = await dispatch(changePassword(values));
              if (success) closeModal();
            }}
            initialValues={{
              current_password: "",
              password: "",
              password_confirmation: ""
            }}
            validationSchema={Yup.object().shape({
              current_password: Yup.string().required(translate("currentPasswordRequired")),
              password: Yup.string()
                .required(translate("newPasswordRequired"))
                .matches(PASSWORD_EXP, translate("passwordRequirements")),
              password_confirmation: Yup.string()
                .required(translate("newPasswordConfirmationRequired"))
                .oneOf([Yup.ref("password")], translate("passwordsDoNotMatch"))
            })}
          >
            {({ isSubmitting, isValid }) => (
              <Form
                style={{ display: "flex", flexDirection: "column", gap: 20 }}
              >
                <TextInput
                  name="current_password"
                  label={translate("currentPassword")}
                  type="password"
                  aria-describedby="password-requirements"
                />
                <TextInput
                  name="password"
                  label={translate("newPassword")}
                  type="password"
                  aria-describedby="password-requirements"
                />
                <TextInput
                  name="password_confirmation"
                  label={translate("newPasswordConfirmation")}
                  type="password"
                  aria-describedby="password-requirements"
                />
                <div id="password-requirements" className="sr-only">
                  {translate("passwordRequirements")}
                </div>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    marginTop: 20,
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  {isSubmitting ? (
                    <Spinner />
                  ) : (
                    <Button
                      type="submit"
                      disabled={!isValid}
                      variant="contained"
                      color="primary"
                    >
                      {translate("submit")}
                    </Button>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}
    />
  );
};

export default ChangePasswordModal;
